import { useTranslation } from "next-i18next";
import { Badge, ChildBadgeProps } from "@ui-kit/data-display/Badge/Badge";
import Icon from "@ui-kit/icons/Icon.web";

export const InstantConfirmationBadge = ({
  isVisible = true,
}: ChildBadgeProps) => {
  const { t } = useTranslation("purchases");
  const icon = (
    <Icon.Orders
      boxSize={{ base: "element.md", sm: "element.xl" }}
      mr="sm"
      aria-label={t("confirmation icon")}
    />
  );

  const text = t("Instant Confirmation");

  return (
    <Badge
      icon={icon}
      text={text}
      isVisible={isVisible}
      data-testid="instant-confirmation-badge"
    />
  );
};
